import { Box, Flex, Heading, Stack, Table, TableContainer, Tbody, Thead } from "@chakra-ui/react"
import { InputSearchFilter } from "components/Atomos/Form/Elements/InputSearch"
import { TableWrapper } from "components/Moleculas/TableWrapper"
import { Pagination } from "components/Organismos/Lists/Pagination"

type TablePageTemplateProps<T> = {
    title?: string;
    newItemButton?: React.ReactNode;
    tableHeader: React.ReactNode;
    filters?: React.ReactNode;
    data: T[];
    renderTableItem: (item: T, index?: number) => React.ReactElement;
    pageProps: {
        index: number;
        totalItems: number;
        pageSize: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isLoading?: boolean;
    }
    onPageChange: (newIndex: number) => void | Promise<void>;
    onSearch?: (search: string) => void | Promise<void>;
}

const TablePageTemplate = <T extends Object>({
    title,
    newItemButton,
    data,
    renderTableItem,
    tableHeader,
    filters,
    pageProps,
    onPageChange,
    onSearch,
}: TablePageTemplateProps<T>) => {
    return (
        <>
            {title && <Heading mb={4}>{title}</Heading>}
            <Stack
                justifyContent="space-between"
                direction={{ base: "column-reverse", md: "row" }}
                mb={2}
            >
                <Box w="full" maxW="450px">
                    <InputSearchFilter onChangeValue={onSearch} />
                </Box>
                {newItemButton && <Flex alignItems="center" justifyContent="flex-end">
                    {newItemButton}                    
                </Flex>}
            </Stack>
            <Pagination
                index={pageProps.index}
                totalItems={pageProps.totalItems}
                pageSize={pageProps.pageSize}
                hasNextPage={pageProps.hasNextPage ?? false}
                hasPreviousPage={pageProps.hasPreviousPage ?? false}
                isLoading={pageProps.isLoading}
                headerComponent={filters}
                loadingSize={60}
                onPageChange={onPageChange}
            >
                <TableWrapper>
                    <TableContainer>
                        <Table size="md">
                            <Thead>
                                {tableHeader}                                
                            </Thead>
                            <Tbody>
                                {data.map(renderTableItem)}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </TableWrapper>
            </Pagination>
        </>
    )
}

export default TablePageTemplate